import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownPosition, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, GuidDefault, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, SmallDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiGetUserList, ApiDeleteEmployee, ApiCheckIsAdmin, ApiGetEmployeeList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetDivision, GetStatus } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import moment from "moment";
import KeyIcon from "assets/icon/KeyIcon";

export default function Employee(){
    let navigate = useNavigate()

    const { data: employeeList, fetch: getEmployeeList } = useFetch(ApiGetEmployeeList)

    const { data: userList, fetch: getUserList } = useFetch(ApiGetUserList)
    const { fetch: deleteEmployee } = useFetch(ApiDeleteEmployee)
    const { fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)

    const [employeeName, setEmployeeName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [idNumber, setIdNumber] = useState(EmptyString)
    const [division, setDivision] = useState(DropdownPosition[0].value)

    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    const divisionChange = (e) => {
        setDivision(e.value)
    }
    const accessBtnClick = (id, name) => {
        navigate("/employee-access?employeeId=" + id + "&employeeName=" + name)
    }

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        fBindGrid(0)
        // fCheckIsAdmin().then(() => {
        //     fBindGrid(0)
        // })
    },[])

    // Function Button
    const addBtnClick = () => {
        navigate("/employee/form?employeeId=&formType=" + FormTypeAdd)
    }
    function fEditBtnClick(id){
        navigate("/employee/form?employeeId=" + id + "&formType=" + FormTypeEdit)
    }
    function fDeleteBtnClick(id, status){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    fDeleteEmployee(id, status).then(() => {
                        setLoading({isOpen: false})
                    })

                    fBindGrid(pageIndex)
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }

    // Function Api Call
    // async function fGetEmployeeList(index){
    //     let res

    //     await getEmployeeList({
    //         data: {
    //             employeeName: employeeName,
    //             address: address,
    //             idNumber: idNumber, 
    //             divisionId: division,
    //             status: status,
    //             pageSize: PageSize,
    //             pageIndex: parseInt(index)
    //         }
    //     }).then((response) => {
    //         if(response.status === ApiResponseSuccess){
    //             res = response
    //         }else if(response.status === ApiResponseStatusUnauthorized){
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                         window.location.href = "/login"
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }else{
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }
    //     })

    //     return res
    // }

    
    async function fGetEmployeeList(index){
        let res

        await getEmployeeList({
            data: {
                employeeName: username,
                idNumber: name, 
                address: address,
                status: status,
                companyId: localStorage.getItem("CompanyId"),
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }

    async function fGetUserList(index){
        let res

        await getUserList({
            data: {
                username: username,
                name: name, 
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteEmployee(employeeId, status){
        await deleteEmployee({
            data: {
                employeeId: employeeId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            fBindGrid(0)
            setLoading(false)
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetEmployeeList(i).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Employee</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-1 w-full sm:w-[280px]">
                        <span>Employee Name</span>
                        <input className="input" value={username} onChange={(e) => { setUsername(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[240px]">
                        <span>ID Number</span>
                        <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[200px]">
                        <span>Position</span>
                        <Dropdown value={division} options={DropdownPosition} onChange={divisionChange} placeholder={"All"} />
                    </div>
                    <div className="flex flex-col gap-1 w-full sm:w-[120px]">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end sm:justify-start items-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-5 overflow-hidden rounded-3xl shadow-sm border">
                <table className="w-full bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Name</th>
                            <th className="font-semibold text-left px-2">Id Number</th>
                            <th className="font-semibold text-left px-2">Date of Join</th>
                            <th className="font-semibold text-left px-2">Position</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="">
                        { employeeList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-t hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.employeeName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.idNumber }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ moment(data.dateOfJoin).format(SmallDateFormat) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ GetDivision(data.divisionId) }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="bg-black rounded px-3 py-1 hover:opacity-50" onClick={() => {accessBtnClick(data.employeeId, data.employeeName)}}>
                                            <KeyIcon className="fill-white w-6" />
                                        </button>
                                        <button className="button flex gap-2" onClick={() => fEditBtnClick( data.employeeId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'block' : 'hidden' }`} onClick={() => fDeleteBtnClick(data.employeeId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? 'block' : 'hidden' }`} onClick={() => fDeleteBtnClick(data.employeeId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}